export default "__VITE_ASSET__BW5ZFY6A__"